module.exports = __webpack_public_path__ + "img/shi3.15cb80ef.png";